import Layout from "./Layout";
import AuthLayout from "./Layout/AuthLayout";

export default {
  Layout,
  AuthLayout,
};
